var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge"},[_vm._t("default"),(_vm.value)?_c('v-sheet',_vm._b({ref:"bullet",staticClass:"bullet",style:(_vm.position),attrs:{"color":_vm.color,"transition":_vm.transition}},'v-sheet',_vm.bullet,false),[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }